import ConfiguratorModal from './ConfiguratorModal';
export default ConfiguratorModal;
